<!--<div *ngIf="!isPopulated" class="insights-cards">
        <div class="insights-card__content" style="margin-bottom: 30px;">
            <ft-spinner block="true"></ft-spinner>
        </div>
    </div>-->
<div edsGrid>
  <div [class]="containerClass">
    <div edsRow>
      <div edsCol>
        <ng-container *ngIf="canShowForm">
          <eds-cta
            [theme]="
              background && background !== 'primary' ? 'primary' : 'secondary-a'
            "
            [edsSpacing]="
              marginBottom && marginBottom !== 'none' ? marginBottom : 'xl'
            "
          >
            <eds-title [title]="title" [theme]="titleColor"></eds-title>
            <div>
              <p [innerHtml]="summary | safeHtml"></p>
            </div>
            <eds-marketo-form
              *ngIf="preferencesLoaded"
              [marketoFormConfig]="formConfig"
              [edsSpacing]="disclaimer && disclaimer !== '' ? 'lg' : ''"
              [marketoPreferencesResult]="userSubscriptionData"
              [retainFormAfterSubmission]="retainFormAfterSubmission"
              [id]="id"
              [successTitle]="successTitle"
              [successMsg]="successMsg"
              (formSubmit)="formAnalytics()"
              [hasUnsubscribeButton]="hasUnsubscribeButton"
              [unsubscribeButtonText]="unsubscribeButtonText"
              [mktoPrefillData]="prefillData"
            ></eds-marketo-form>
            <div>
              <p [innerHtml]="disclaimer | safeHtml"></p>
            </div>
          </eds-cta>
        </ng-container>
        <ng-container *ngIf="!canShowForm">
          <div [innerHtml]="marketoFormPrivacy | safeHtml"></div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
